import { __ } from '../../../utils';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import { Button, useLinkProps } from '@presov.sk/presov-ui-react';
import React from 'react';

const HREF = '/administracia/kategorie-podnetov';

/**
 * Vstup do správy kategórií podnetov z hlavičky zoznamu. Je to **odkaz**, nie
 * tlačidlo s `navigate` - cmd klik ho otvorí v novej karte a obyčajný klik ide
 * cez router, ktorý knižnici dodáva shell (`useLinkProps`).
 */
const ReportCategoriesButton: React.FC = () => {
  const link = useLinkProps(HREF);

  return (
    <Button
      variant='outline'
      size='small'
      startIcon={<CategoryOutlinedIcon fontSize='small' />}
      {...link}
    >
      {__('Spravovať kategórie')}
    </Button>
  );
};

export default ReportCategoriesButton;
